import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.65rem 2rem',
  borderRadius: '0.5rem',
  gap: '0.5rem',
  transition: '0.3s',
  cursor: 'pointer',
  userSelect: 'none',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
